import './CancelModal.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';
import Error from '../../../../common/Error/Error';
import { useLocation, useNavigate } from 'react-router';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';

// General CancelModal Component
const CancelModal = ({ category, id, movementType, setModalOpen }) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const navigate = useNavigate();
  const location = useLocation();

  const cancelMovement = () => {
    if (movementType == 'collections' || movementType == 'imports') {
      setLoading(true);
      GoodsIn.cancel(category, id)
        .then(() => {
          setLoading(false);
          navigate(`/${location?.pathname?.split('/')[1]}`);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
    if (movementType == 'deliveries' || movementType == 'exports') {
      setLoading(true);
      GoodsOut.cancel(category, id)
        .then(() => {
          setLoading(false);
          navigate(`/${location?.pathname?.split('/')[1]}`);
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
  };

  return (
    <div className="cancel_movement_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">{`Cancel this ${
        movementType == 'deliveries'
          ? 'delivery'
          : movementType.substring(0, movementType.length - 1)
      }?`}</div>
      <div className="cancel_movement_buttons">
        <button className="cancel_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button className="ok_button" onClick={() => cancelMovement()}>
          OK
        </button>
      </div>
    </div>
  );
};

CancelModal.propTypes = {
  category: PropTypes.string,
  movementType: PropTypes.string,
  id: PropTypes.number,
  setModalOpen: PropTypes.func,
};

export default CancelModal;
